import React, { useCallback, useEffect, useMemo, useState } from "react";
import { companyCrudApi, syncCompanies } from "./CompaniesApi";
import { defaultCompany } from "./Company";
import { CompanyForm } from "./CompanyForm";
import { EntityListAndEditPage } from "../../shared/components/page/EntityListAndEditPage";
import { companiesTableColumns } from "./companiesTableColumns";
import { useTranslation } from "react-i18next";
import { Grid, MenuItem, useMediaQuery, useTheme } from "@mui/material";
import { useAxios } from "../../shared/technical/rest/AxiosProvider";
import { SpecialMenu } from "../../shared/components/menu/SpecialMenu";
import { TableOptions } from "../../shared/components/tables/PaginatedContentPageTable";
import { CompaniesPageTitle } from "./CompaniesPageTitle";
import {
  CompaniesListFilters,
  CompaniesListFiltersBar,
  filtersToQueryString,
} from "./CompaniesListFilters";

export function CompaniesPageContent() {
  const { t, i18n } = useTranslation();
  const theme = useTheme();
  const smallScreens = useMediaQuery(theme.breakpoints.down('sm'));
  const axios = useAxios();
  const [ columns, setColumns ] = useState(companiesTableColumns(t, i18n.language, smallScreens));
  const [ companyCount, setCompanyCount ] = useState<number>(0);
  const [ filters, setFilters ] = useState<CompaniesListFilters>({});

  useEffect(() => {
    setColumns(companiesTableColumns(t, i18n.language, smallScreens));
  }, [ t, i18n.language, smallScreens ]);

  const filterParams = useMemo(() => filtersToQueryString(filters), [ filters ]);

  const handleFiltersChange = useCallback((newFilters: CompaniesListFilters) => {
    setFilters(newFilters);
  }, []);

  const tableOptions: TableOptions = {
    search: false,
    filter: false,
  }

  return (
    <>
      <EntityListAndEditPage crudApi={companyCrudApi}
                             columns={columns}
                             defaultEntity={defaultCompany}
                             title={<CompaniesPageTitle companyCount={companyCount} />}
                             additionalHeaderItem={
                               <Grid item sx={{ marginLeft: "auto" }}>
                                 <SpecialMenu>
                                   <MenuItem onClick={() => {
                                     return syncCompanies(axios);
                                   }}>
                                     {t("Company.syncCompanies")}
                                   </MenuItem>
                                 </SpecialMenu>
                               </Grid>
                             }
                             aboveTable={
                               <CompaniesListFiltersBar onFiltersChange={handleFiltersChange} />
                             }
                             additionalQueryParams={filterParams}
                             onTotalCountChange={setCompanyCount}
                             i18nPrefix={'Company'}
                             isEditable={true}
                             editForm={(entity, handleSave, handleDelete, handleClose) =>
                               <CompanyForm company={entity} handleSave={handleSave} handleDelete={handleDelete}
                                            handleClose={handleClose} />}
                             tableOptions={tableOptions}
      />
    </>
  )
}
